<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
        <transition name="slide-fade">
            <div class="vx-col xs:w-full md:w-1/2 lg:w-3/12 xl:w-2/12 m-4" v-show="showCompanies">
                <vx-card card-background="#fff8f1">
                    <div class="vx-card__title mb-4">
                        <h3 class="text-center text-warning truncate"> <a-icon type="plus" /> {{ isSmallerScreen ? 'Nova' : 'Nova Empresa' }}</h3>
                        <p class="text-center">Administrador</p>
                    </div>

                    <img src="@/assets/images/logo/no-photo-crane.png" alt="" class="mx-auto mb-2" width="150">

                    <vs-button @click="() => $router.push('/companyCreate/')" color="warning" type="relief" class="w-full mt-4 truncate">{{ isSmallerScreen ? 'CRIAR' : 'CRIAR EMPRESA' }}</vs-button>
                </vx-card>
            </div>
        </transition>

        <transition name="slide-fade">
            <a-spin>
                <a-icon slot="indicator" type="loading" style="font-size: 28px" spin v-show="loading" />
            </a-spin>
        </transition>

        <transition name="slide-fade">
            <span class="ml-4" v-show="loading"> Carregando informações ... </span>
        </transition>

        <div class="vx-col xs:w-full md:w-1/2 lg:w-3/12 xl:w-2/12 m-4" v-for="company in invitedByCompanies" :key="company.id">
            <transition name="slide-fade">
                <company-card v-show="showCompanies" :data="company" :isCardInvite="true" />
            </transition>
        </div>

        <div class="vx-col xs:w-full md:w-1/2 lg:w-3/12 xl:w-2/12 m-4" v-for="company in companies" :key="company.id">
            <transition name="slide-fade">
                <company-card v-show="showCompanies" :data="company" :default="companies.length == 1 && forceSelect == '0'" />
            </transition>
        </div>
        
        <vx-tooltip title="Ajuda" text="Sair da conta atual">
            <transition name="slide-fade">
                <vs-button radius color="danger" type="gradient" icon-pack="feather" icon="icon-log-out" size="large" @click="logout" v-show="showCompanies"></vs-button>
            </transition>
        </vx-tooltip>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import CompanyCard from '@/components/company/CardSelectCompany'
    import { mapMutations } from 'vuex'

    export default {
        props : {
            forceSelect : {
                required : true
            }
        },

        components : {
            CompanyCard
        },

        mounted () {
            if(this.$store.getters.getUserStoredData == null) {
                this.$router.push('/login/')
            } else {
                this.cleanUpNotifications()
                this.getAvailableCompanies ()
                this.getCompanyInvitations()
            }            
        },

        data () {
            return {
                companies : [],
                invitedByCompanies : [],
                ref : firebase.firestore(),
                showCompanies : false,
                loading : true
            }
        },

        computed: {
            isSmallerScreen() {
                return this.$store.state.windowWidth < 768
            }
        },

        methods : {
            async getCompanyInvitations () {
                let uid       = this.$store.getters.getUserStoredData.id || this.$store.getters.getUserStoredData.uid
                let companies = await this.ref.collectionGroup('employeeRequests')
                                              .where('uid', '==', uid)
                                              .where('accepted', '==', false)
                                              .where('active', '==', true)
                                              .get()
                
                let promiseAll = companies.docs.map(async company => {
                    let companyId = company.ref.parent.parent.id
                    return await this.ref.collection('company').doc(companyId).get()
                })

                let invitesFromCompany = await Promise.all(promiseAll)
                invitesFromCompany.forEach(i => {
                    companies.docs.forEach(c => {
                        if(c.ref.parent.parent.id == i.id) {
                            this.invitedByCompanies.push({id: i.id, ...i.data(), invitationId : c.id, role : c.data().role})
                        }
                    })
                })
            },

            async getAvailableCompanies () {
                let uid       = this.$store.getters.getUserStoredData.id || this.$store.getters.getUserStoredData.uid
                let companies = await this.ref.collectionGroup('companyUsers')
                                              .where('uid', '==', uid)
                                              .where('blocked', '==', false)
                                              .get()

                let promises = Object.entries(companies.docs).map(doc => {
                    let companyId = doc[1].ref.parent.parent.id
                    return this.getCompanyInfo(companyId)
                })

                let results = await Promise.all(promises)
                let arrCompanies = []
                companies.forEach(user => {
                    let userData = user.data()
                    let role = userData.role
                    let companyId = user.ref.parent.parent.id
                    let companyInfo = results.find(a => a.id == companyId)
                    
                    arrCompanies.push({...companyInfo, ...{ role : role }})
                })

                this.companies = arrCompanies
                this.loading = false

                setTimeout(() => {
                    this.showCompanies = true
                }, 1000)
            },

            getCompanyInfo (companyId) {
                return new Promise(async resolve => {
                    let companyInfo = await this.ref.collection('company').doc(companyId).get()
                    let company = companyInfo.data();
                    company.id = companyId;
                    resolve(company)
                })
            },

            logout() {
                this.$store.dispatch('logout')
            },

            ...mapMutations('notifications', ['cleanUpNotifications'])
        }
    }
</script>

<style lang="scss">
    .slide-fade-enter-active {
    transition: all .3s ease;
    }
    .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for <2.1.8 */ {
    transform: translateX(20px);
    opacity: 0;
    }

</style>